"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergedRef = void 0;
function useMergedRef() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (node) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                ref(node);
            }
            else if (ref != null) {
                // eslint-disable-next-line no-param-reassign
                ref.current = node;
            }
        });
    };
}
exports.useMergedRef = useMergedRef;
